<template>
  <div>
    <b-overlay :show="loadData" spinner-variant="primary" spinner-type="grow" spinner-small rounded="md">
      <!-- <div class="loading" v-if="fetchData">
        <load-data></load-data>
      </div> -->
      <b-modal id="topicCoveredModel" hide-footer centered size="md">
        <span v-if="lesson_plans">Topics : {{ lesson_plans }}</span>
        <span v-else class="text-danger">The topic for this attendance has not been updated by the faculty.</span><br>
        <span v-if="delivery_methods">Delivery Methods : {{ delivery_methods }}</span>
      </b-modal>
      <div class="studentAttendence">
        
          <table class="table table-striped table-bordered" v-if="!loadData">
            <thead>
              <tr>
                <th colspan="100" class="text-center">Attendance Report</th>
              </tr>
              <tr v-if="from_parent_login && studentAttendanceData.length == 0" style="text-align: center; color: red;">
                  <td colspan="100%">Not Updated Yet</td>
              </tr>
              <tr>
                <th></th>
                <th v-for="(session, sessionIndex) in sessions" :key="sessionIndex" class="text-capitalize">
                  {{ session.name }}
                </th>
              </tr>
            </thead>
            <tbody>
              <tr v-for="(attDate, attIndex) in attendanceDates" :key="attIndex">
                <td>{{ attDate.date }}-{{ attDate.day }}</td>
                <td v-for="(session, sessionIndex) in sessions" :key="sessionIndex" class="text-center">
                  <span v-if="studentAttendanceData[attDate.key][session.id].attendance" style="">
                    <span class="attType" :style="attendanceTypes[studentAttendanceData[attDate.key][session.id].attendance].positive_report_value == '1' ? 'color:green;' : 'color:red;'">
                      {{
                      attendanceTypes[studentAttendanceData[attDate.key][session.id].attendance].code
                      }}</span><br />
                    <span class="course">
                      {{
                      courses[studentAttendanceData[attDate.key][session.id].course]
                      .name
                      }}</span><br />
                    <span class="btn p-0 m-0 text-info font-weight-bolder" @click="topicCovered(studentAttendanceData[attDate.key][session.id].lesson_plans,
                      studentAttendanceData[attDate.key][session.id].delivery_methods
                    )">Topic Covered</span>
                    <br />
                    <span class="course">
                      {{
                        studentAttendanceData[attDate.key][session.id].class_type
                      }}</span>
                  </span>
                </td>
              </tr>
            </tbody>
          </table>
       
      </div>
    </b-overlay>
  </div>
</template>

<script>
// import acl from "../../../../../authorization/acl.js";

export default {
 props: ["from_parent_login", "parentSelectedInstitutionUserId", "parentSelectedAcademicYear"],
  async created() {
    this.getStudentAttendanceDetailedReport();
  },
  data() {
    return {
      loadData: true,
      courses: {},
      sessions: {},
      attendanceTypes: {},
      studentAttendanceData: {},
      attendanceDates: {},
      lesson_plans:'',
      delivery_methods:''
    };
  },
  methods: {
    topicCovered(lesson_plans,delivery_methods){
      this.lesson_plans = lesson_plans;
      this.delivery_methods = delivery_methods;
      this.$bvModal.show('topicCoveredModel');
    },
    getStudentAttendanceDetailedReport() {
      this.loadData = true;
      let mainUrl = this.$store.getters.getAPIKey.mainAPI;

      let url = "";
      let params = {};

      if (this.from_parent_login) {
        const lastDashIndex = this.parentSelectedAcademicYear.lastIndexOf("-");
        if (lastDashIndex === -1) {
          return;
        }

        url = `${mainUrl}/parentuser/attendancereports/student/detailed`;
        params = {
          institution_user_id: this.parentSelectedInstitutionUserId,
          academic_year: this.parentSelectedAcademicYear.substring(0, lastDashIndex),
          academic_semester: this.parentSelectedAcademicYear.substring(lastDashIndex + 1),
        };
      } else {
        url = `${mainUrl}/attendancereports/student/detailed`;
        params = {};
      }

      this.$axios
        .post(url, params)
        .then((response) => {
          let responseData = response.data;
          this.courses = responseData.courses;
          this.sessions = responseData.sessions;
          this.attendanceTypes = responseData.attendanceTypes;
          this.studentAttendanceData = responseData.studentAttendanceData;
          this.attendanceDates = responseData.attendanceDatesArray;
          this.loadData = false;
        })
        .catch((error) => {
          error;
          this.loadData = false;
        });
    },
  },
};
</script>

<style >
.attType {
  font-size: 12px !important;
}

.course {
  font-size: 10px !important;
}

.selectReportType .list-group .list-group-item {
  font-size: 14px;
  font-weight: 600;
  padding: 5px;
}
</style>
